import styles from '@styles/PaginationDots.module.css'
import PropTypes from 'prop-types'

const PaginationDots = ({ currentPage, totalPages }) => {
  return (
    <div className={styles.paginationDots}>
      {Array.from({ length: totalPages }).map((_, index) => (
        <button
          key={index}
          className={`${styles.paginationDot} ${
            index === currentPage ? styles.active : ''
          }`}
          aria-label={`Page ${index + 1}`}
        />
      ))}
    </div>
  )
}
PaginationDots.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
}

export default PaginationDots
